// @flow
import $ from "jquery";
import React from "react";
import ReactDOM from "react-dom";

import ApEditor, { EditorMode } from "./components/ApEditor.js";
import SummaryPreviewContainer from "./components/SummaryPreviewContainer.js";

var editors = [];

function updateNativeInputs() {
  for (let editor of editors) {
    if (editor instanceof ApEditor) {
      editor.updateNativeInput();
    }
  }
}

export function initializeApEditor(
  textInput: HTMLInputElement
): React$Component<> {
  $(textInput).prop("required", false);
  let editorMode = $(textInput).attr("js-ap-editor");
  let reactContainer = document.createElement("div");
  textInput.after(reactContainer);
  return ReactDOM.render(
    <ApEditor nativeInput={textInput} mode={editorMode} />,
    reactContainer
  );
}

for (let textInput of $("[js-ap-editor]")) {
  editors.push(initializeApEditor(textInput));
}

const summaryPreviewContainer = $("[js-summary-preview]")[0];
if (summaryPreviewContainer !== undefined) {
  ReactDOM.render(
    <SummaryPreviewContainer updateNativeInputsFn={updateNativeInputs} />,
    summaryPreviewContainer
  );
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/wysiwyg.js